import { Card, Table } from "react-bootstrap";
import type { AccountRecord } from "../lib/explainTypes";
import SummaryRow from "./SummaryRow";

interface Props {
  accounts: AccountRecord[];
}

// Reads `response.accounts`. Per architecture spec §8 + §12 rule 6:
// matrix overview at the top of the page; per-account blocks below are
// the narrative. The `final` slice (household rollup) is consumed by
// `FinalPanel` lower on the page; we deliberately do not repeat a
// household-total band here so each per-account table is self-contained.
export default function SummaryTable({ accounts }: Props) {
  return (
    <Card className="mb-3">
      <Card.Header>Summary</Card.Header>
      <Card.Body>
        <Table size="sm" responsive>
          <tbody>
            {accounts.map((a) => (
              <SummaryRow key={a.account_id} account={a} />
            ))}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}
